import { Card, FormField, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { GalleryDetailsFieldsView } from '../../../../types/form-types'
import LocationFieldView from '../../wells/location-field-view'

interface WellConstructionGalleryViewInterface {
  fields: Partial<GalleryDetailsFieldsView>
  index: number
  isLoading: boolean
}

export default function WellConstructionGalleryView({
  fields,
  index,
  isLoading,
}: WellConstructionGalleryViewInterface) {
  return (
    <Card>
      <LocationFieldView
        index={index}
        isLoading={isLoading}
        formFieldLabel='Start coordinates'
        easting={{
          labelId: 'galleryStartEasting',
          value: `${fields.galleryStartEasting ?? ''}`,
        }}
        northing={{
          labelId: 'galleryStartNorthing',
          value: `${fields.galleryStartNorthing ?? ''}`,
        }}
        latitude={{
          labelId: 'galleryStartLatitude',
          value: `${fields.galleryStartLatitude ?? ''}`,
        }}
        longitude={{
          labelId: 'galleryStartLongitude',
          value: `${fields.galleryStartLongitude ?? ''}`,
        }}
      />

      <LocationFieldView
        isLoading={isLoading}
        formFieldLabel='End coordinates'
        easting={{
          labelId: 'galleryEndEasting',
          value: `${fields.galleryEndEasting ?? ''}`,
        }}
        northing={{
          labelId: 'galleryEndNorthing',
          value: `${fields.galleryEndNorthing ?? ''}`,
        }}
        latitude={{
          labelId: 'galleryEndLatitude',
          value: `${fields.galleryEndLatitude ?? ''}`,
        }}
        longitude={{
          labelId: 'galleryEndLongitude',
          value: `${fields.galleryEndLongitude ?? ''}`,
        }}
      />

      <FormField
        toolTipMessage={TOOLTIP.galleryDepth}
        isSkeleton={isLoading}
        label='Gallery depth (m)'
        labelId='galleryDepthLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='galleryDepthLabel' value={fields.galleryDepth} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Gallery length (m)' labelId='galleryLengthLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='galleryLengthLabel' value={fields.galleryLength} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.galleryWidth}
        isSkeleton={isLoading}
        label='Gallery width (mm)'
        labelId='galleryWidthLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='galleryWidthLabel' value={fields.galleryWidth} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.galleryDirectionId}
        isSkeleton={isLoading}
        label='Gallery direction'
        labelId='galleryDirectionLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='galleryDirectionLabel' value={fields.galleryDirection} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Casing type' labelId='casingMaterialLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='casingMaterialLabel' value={fields.casingMaterial} />
      </FormField>
    </Card>
  )
}
